import { trans } from "@mongez/localization";
import { useClearCart } from "core/cart";
import { Button, errorToast, successToast } from "~/design-system/components";
import { CloseIcon } from "~/design-system/components/icons/action-icons";
import { triggerCartCleared } from "~/modules/cart/events";
import { cartDrawerAtom } from "~/modules/shared/atoms/cart-drawer.atom";

type CartHeaderProps = {
  totalItems: number;
};

export function CartHeader({ totalItems }: CartHeaderProps) {
  const { clearCart } = useClearCart({
    onSuccess: (data) => {
      triggerCartCleared();
      successToast(trans("cartClearedSuccess"));
    },
    onError: (error: any) => {
      errorToast(error);
    },
  });

  // useEffect(() => {
  //   return () => {
  //     cartClearedEvent.unsubscribe();
  //   };
  // }, []);

  return (
    <div className="flex items-center justify-between gap-4 border-b px-10 pt-8 pb-6">
      <h3 className="text-2xl font-bold">
        {trans("cart.bag")}{" "}
        {!!totalItems && (
          <span>{trans("cart.itemsNumber", { count: totalItems })}</span>
        )}
      </h3>
      {!!totalItems && (
        <Button
          onClick={clearCart}
          className="text-primary-default hover:text-primary-900 mt-2 p-0 underline"
        >
          {trans("clear")}
        </Button>
      )}
      <Button
        onClick={cartDrawerAtom.close}
        className="hover:bg-primary-light grid cursor-pointer place-items-center rounded-full border p-3 ltr:ml-auto rtl:mr-auto"
      >
        <CloseIcon className="size-5" />
      </Button>
    </div>
  );
}
